// commponents.
import LayoutSidebar from '../../components/LayoutSidebar';
import LayoutSidebarMx from '../../components/LayoutSidebarMx';
import { ApproverTaskTable } from './components/ApproverTaskTable/ApproverTaskTable';

// styles.
import LayoutHeaderClean from '../../components/LayoutClean';
import { ContainerPage, LayoutWrapper } from '../../components/Layout/style';

export const ApproverTasks = () => {
  const country = localStorage.getItem('country');
  const Sidebar = country === 'MX' ? LayoutSidebarMx : LayoutSidebar;

  return (
    <LayoutWrapper style={{ height: '100vh' }}>
      <div style={{ display: 'grid', gridColumn: '1/3', height: '100vh' }}>
        <Sidebar />
      </div>
      <ContainerPage style={{ height: '100vh' }}>
        <LayoutHeaderClean />
        <ApproverTaskTable />
      </ContainerPage>
    </LayoutWrapper>
  );
};
